import { Icon } from '@mxenabled/mx-icons'

import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import IconButton from '@mui/material/IconButton'
export interface DeepLinkDialogCopyObject {
  close_dialog_aria: string
  title: string
}
export interface DeepLinkDrawerProps {
  copy: DeepLinkDialogCopyObject
  onClose: () => void
  setShouldShow: (shouldShow: boolean) => void
  shouldShow: boolean
}

export const DeepLinkDialog: React.FC<React.PropsWithChildren<DeepLinkDrawerProps>> = ({
  children,
  copy,
  shouldShow,
  onClose,
  // Destructured out (though unused here) so it does NOT fall into ...rest and
  // get spread onto the MUI <Dialog> DOM node (React "does not recognize the
  // setShouldShow prop" warning).
  setShouldShow: _setShouldShow,
  ...rest
}) => {
  return (
    <Dialog fullScreen={true} onClose={onClose} open={shouldShow} {...rest}>
      <DialogTitle>{copy.title}</DialogTitle>
      <IconButton
        aria-label={copy.close_dialog_aria}
        onClick={onClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
        }}
      >
        <Icon name="close" />
      </IconButton>
      <DialogContent sx={{ mb: 24 }}>{children}</DialogContent>
    </Dialog>
  )
}
